module.exports = __webpack_public_path__ + "img/levelback1.d6af74a2.svg";